/**
 *
 * @constructor
 */
function SymmetricCipherBase(cryptoService) {
  this.cryptoService = cryptoService;
}

/**
 * Generates an IV of the appropriate length for the algorithm
 * @returns
 */
SymmetricCipherBase.prototype.generateInitializationVector = function () {
  return this.cryptoService.generateInitializationVector(this.ivLength);
};

/**
 *
 * @returns
 */
SymmetricCipherBase.prototype.generateKey = function () {
  return this.cryptoService.generateKey(this.keyLength);
};

const requireOverride = function overrideRequired() {
  throw new Error('Override required');
};

SymmetricCipherBase.prototype.encrypt = requireOverride;
SymmetricCipherBase.prototype.decrypt = requireOverride;

module.exports = SymmetricCipherBase;
